var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-btns-father" },
    [
      _c("div", { staticClass: "page-btns-main" }, [
        _c("div", { staticClass: "common-title" }, [_vm._v("发票上传")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-main common no-shadow common-form-inline" },
          [
            _c(
              "a-form-model",
              {
                ref: "ruleForm",
                attrs: {
                  rules: _vm.ruleForm,
                  model: _vm.pageData,
                  "label-col": { span: 6 },
                  "wrapper-col": { span: 13 }
                }
              },
              [
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          { attrs: { label: "买方名称" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { "white-space": "nowrap" } },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.pageData.buryName))
                                ]),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "16px" } },
                                  [_vm._v(_vm._s(_vm.pageData.buryOrgCode))]
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { label: "发票上传", prop: "tblBlId" }
                          },
                          [
                            _c("imgUpload", {
                              staticStyle: { height: "120px" },
                              attrs: {
                                file: _vm.fileList,
                                paramObj: _vm.uploadParam,
                                name: "file"
                              },
                              on: {
                                remove: _vm.removeOk,
                                uploadOk: _vm.uploadOk
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-color-orange img-tip" },
                              [
                                _vm._v(
                                  "\n                温馨提示：请核对系统读取的票面要素信息，如有错误，请务必修改。若无法读取，请上传清晰票面或手工输入。发票票面需含有发票专用章。\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          { attrs: { label: "发票类型", prop: "invoiceType" } },
                          [
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  allowClear: true,
                                  disabled: _vm.formDisabled,
                                  placeholder: "请选择"
                                },
                                on: { change: _vm.invTypeChange },
                                model: {
                                  value: _vm.pageData.invoiceType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.pageData, "invoiceType", $$v)
                                  },
                                  expression: "pageData.invoiceType"
                                }
                              },
                              _vm._l(_vm.invoiceTypes, function(item) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: item.dctVal,
                                    attrs: {
                                      value: item.dctVal,
                                      label: item.dctValNm
                                    }
                                  },
                                  [_vm._v(_vm._s(item.dctValNm))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.pageData.invoiceType == 4
                          ? _c(
                              "a-form-model-item",
                              { attrs: { label: "发票代码" } },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    disabled: true
                                  },
                                  model: {
                                    value: _vm.pageData.invoiceCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.pageData, "invoiceCode", $$v)
                                    },
                                    expression: "pageData.invoiceCode"
                                  }
                                })
                              ],
                              1
                            )
                          : _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "发票代码",
                                  prop: "invoiceCode"
                                }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    disabled: _vm.formDisabled
                                  },
                                  model: {
                                    value: _vm.pageData.invoiceCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.pageData, "invoiceCode", $$v)
                                    },
                                    expression: "pageData.invoiceCode"
                                  }
                                })
                              ],
                              1
                            )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          {
                            attrs: { label: "发票号码", prop: "invoiceNumber" }
                          },
                          [
                            _c("a-input", {
                              attrs: {
                                placeholder: "请输入",
                                disabled: _vm.formDisabled
                              },
                              model: {
                                value: _vm.pageData.invoiceNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.pageData, "invoiceNumber", $$v)
                                },
                                expression: "pageData.invoiceNumber"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          { attrs: { label: "开票日期", prop: "billTime" } },
                          [
                            _c("a-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请输入",
                                disabled: _vm.formDisabled,
                                valueFormat: "YYYY-MM-DD"
                              },
                              model: {
                                value: _vm.pageData.billTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.pageData, "billTime", $$v)
                                },
                                expression: "pageData.billTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.pageData.invoiceType == 2 ||
                    _vm.pageData.invoiceType == 3
                      ? _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "发票校验码后六位",
                                  prop: "checkCode"
                                }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    disabled: _vm.formDisabled
                                  },
                                  model: {
                                    value: _vm.pageData.checkCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.pageData, "checkCode", $$v)
                                    },
                                    expression: "pageData.checkCode"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pageData.invoiceType == 0 ||
                    _vm.pageData.invoiceType == 1
                      ? _c(
                          "a-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: "发票金额",
                                  prop: "invoiceAmount"
                                }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder: "请输入",
                                    type: "number",
                                    disabled: _vm.formDisabled,
                                    suffix: "(不含税)元"
                                  },
                                  model: {
                                    value: _vm.pageData.invoiceAmount,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.pageData,
                                        "invoiceAmount",
                                        $$v
                                      )
                                    },
                                    expression: "pageData.invoiceAmount"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label: "发票金额",
                              prop: "invoiceAmountWithVat"
                            }
                          },
                          [
                            _c("a-input", {
                              attrs: {
                                placeholder: "请输入",
                                type: "number",
                                suffix: "(含税)元"
                              },
                              model: {
                                value: _vm.pageData.invoiceAmountWithVat,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.pageData,
                                    "invoiceAmountWithVat",
                                    $$v
                                  )
                                },
                                expression: "pageData.invoiceAmountWithVat"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "spaceCenter",
                staticStyle: { margin: "24px 0 0 0" }
              },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "btn-blue-line",
                    staticStyle: { "margin-right": "10px" },
                    on: { click: _vm.resetForm }
                  },
                  [_vm._v("重置")]
                ),
                _vm._v(" "),
                _c("button-load", {
                  attrs: { type: "primary", lable: "导入列表" },
                  on: { clickHandle: _vm.importTable }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "common-title" }, [_vm._v("发票列表")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-common common" },
          [
            _c("a-table", {
              attrs: {
                size: "middle",
                columns: _vm.columns,
                "row-key": function(record) {
                  return record.id
                },
                "data-source": _vm.tableData,
                loading: _vm.loading,
                bordered: "",
                locale: { emptyText: "暂无数据" }
              },
              scopedSlots: _vm._u([
                {
                  key: "invoiceType",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("invoiceTypeFilter")(text)) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "invoiceCode",
                  fn: function(text, record) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(+record.invoiceType === 4 ? "--" : text) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "invoiceAmountWithVat",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("splitK")(text)) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "invoiceAmount",
                  fn: function(text) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("splitK")(text)) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "checkCode",
                  fn: function(text, record) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            +record.invoiceType === 0 ||
                              +record.invoiceType === 1
                              ? "--"
                              : text
                          ) +
                          "\n        "
                      )
                    ]
                  }
                },
                {
                  key: "oper",
                  fn: function(text, record, index) {
                    return [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.toInvInfo(record)
                            }
                          }
                        },
                        [_vm._v("查看")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "text-color-orange",
                          on: {
                            click: function($event) {
                              return _vm.toRevoke(record, index)
                            }
                          }
                        },
                        [_vm._v("撤销")]
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text-color-orange",
                staticStyle: { "margin-top": "10px" }
              },
              [
                _vm._v(
                  "\n        温馨提示：若列表中含融资已使用的发票，请务必撤销。\n      "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter page-bottom-btns" },
        [
          _c(
            "a-button",
            {
              staticClass: "btn-blue-line",
              staticStyle: { margin: "0 5px" },
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c("button-load", {
            attrs: { type: "primary", lable: "去查验" },
            on: { clickHandle: _vm.gotoCheck }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("invoiceInfo", {
        ref: "invoiceInfo",
        attrs: { info: _vm.curRow, readonly: true },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("receivableImportReslut", { ref: "receivableImportReslut" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c6f05eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6f05eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-manage/receivable/receivable-import.vue
// module id = loCq
// module chunks = 1